import React from 'react';
import axios from 'axios';
import {withRouter} from "react-router-dom";
var moment = require('moment')

class UserPreview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstname: '',
            surname: '',
            email: '',
            address: '',
            phoneNumber: '',
            nickname: '',
            gender: '',
            age: '',
            dateOfBirth: '',
            dlGroups: '',
            yearKm: '',
            drivenCarTypes: '',
            insuranceCategory: '',
            yearDLObtained: '',
            deviceCode: ''
        }
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getUser();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getUser();
        }
    }

    getUser() {
        const { sessionData } = this.props;
        if (this.props.match.params.id) {
            const config = {
                headers: {
                    Authorization: `Bearer ${sessionData.accessToken}`
                }
            }
            axios.get(this.props.api.users + "/" + this.props.match.params.id, config)
            .then((response) => {
                if (!this._componentWillUnmount) {
                    this.setState({
                        ...response.data
                    });
                }
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst uživatele!');
                console.log('Axios error: ', error);
            });
        }
    }

    render() {
        let {
            firstname,
            surname,
            email,
            address,
            phoneNumber,
            nickname,
            gender,
            age,
            dateOfBirth,
            dlGroups,
            yearKm,
            drivenCarTypes,
            insuranceCategory,
            yearDLObtained,
            deviceCode
        } = this.state;

        console.log("adresa", address);
        var addressOut = ''
        if (address.street && address.street !== '') {
            addressOut += address.street;
        }
        if (addressOut !== '') addressOut += ", ";
        if (address.number && address.number !== '') {
            addressOut += address.number;
        }
        if (addressOut !== '') addressOut += ", ";
        if (address.zip && address.zip !== '') {
            addressOut += address.zip;
        }
        if (addressOut !== '') addressOut += ", ";
        if (address.city && address.city !== '') {
            addressOut += address.city;
        }
        if (addressOut !== '') addressOut += ", ";
        if (address.region && address.region !== '') {
            addressOut += address.region;
        }
        if (addressOut !== '') addressOut += ", ";
        if (address.state && address.state !== '') {
            addressOut += address.state;
        }
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Náhled uživatele</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <h2>Kontaktní informace:</h2>
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    <th>Jméno a příjmení:</th>
                                    <td>{firstname} {surname}</td>
                                </tr>
                                <tr>
                                    <th>E-mail:</th>
                                    <td>{email}</td>
                                </tr>
                                <tr>
                                    <th>Telefon:</th>
                                    <td>{phoneNumber}</td>
                                </tr>
                                <tr>
                                    <th>Adresa:</th>
                                    <td>{addressOut}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <h2>Osobní informace:</h2>
                        <table className="table table-striped">
                            <tbody>
                            <tr>
                                <th>Přezdívka:</th>
                                <td>{nickname}</td>
                            </tr>
                            <tr>
                                <th>Pohlaví:</th>
                                <td>{gender ? (gender === 'M' ? 'Muž' : 'Žena') : ''}</td>
                            </tr>
                            <tr>
                                <th>Datum narození:</th>
                                <td>{dateOfBirth ? moment(dateOfBirth).format('DD.MM.YYYY') : ''}</td>
                            </tr>
                            <tr>
                                <th>Věk:</th>
                                <td>{age}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h2>Další informace:</h2>
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    <th>Řidičská oprávnění:</th>
                                    <td>{Array.isArray(dlGroups) ? dlGroups.join(', ') : 'žádná'}</td>
                                </tr>
                                <tr>
                                    <th>Ročně najede:</th>
                                    <td>{yearKm}</td>
                                </tr>
                                <tr>
                                    <th>Doba vlastnění řidičského oprávnění:</th>
                                    <td>{yearDLObtained}</td>
                                </tr>
                                <tr>
                                    <th>Typ řízeného vozidla:</th>
                                    <td>{drivenCarTypes}</td>
                                </tr>
                                <tr>
                                    <th>Kategorie pojištění:</th>
                                    <td>{insuranceCategory}</td>
                                </tr>
                                <tr>
                                    <th>Kód zařízení:</th>
                                    <td>{deviceCode}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(UserPreview);



/** WEBPACK FOOTER **
 ** ./src/containers/Users/UserPreview.js
 **/